// @flow

import React, { Fragment } from "react";
import { View } from "@components";
import { Column } from "../column";
import type { ColumnType } from "../../types";

type Props = {|
  column: ColumnType,
|};

export const SubColumns = (props: Props) => (
  <View name="ColumnsContainerSubColumns">
    <Column column={props.column} />
    {/* rows of data */}
    <View
      name="SubColumns-Row"
      gap={3}
      justifyContent="space-between"
      direction="row"
      padding={[3, 0, 0, 0]}
    >
      {(props.column.data || []).map((keyValue, index) => (
        <View
          name="SubColumns-subColumn"
          xs={props.column.subColumns ? 12 / props.column.subColumns : null}
          key={`subColumn-${index}`}
        >
          <div className="pb-1 row-label">{keyValue[0]}</div>
          <div className="row-value">{keyValue[1]}</div>
        </View>
      ))}
    </View>
  </View>
);

export default SubColumns;
